@if (showTable) {
  <snelstart-ui-table [config]="tableConfig">
    <snelstart-ui-table-col
      columnType="string"
      name="label"
      [showFilter]="false"
      [showSort]="false"
      width="600"
    >
      <snelstart-ui-table-col-header>
        {{ clientName || ' ' }}
      </snelstart-ui-table-col-header>

      <snelstart-ui-table-expanded-row>
        @for (option of options; track option.value) {
          @for (subOnderdeel of option.subonderdelen ?? []; track subOnderdeel.value) {
            @if (subOnderdeel.visible) {
              <div>
                <snelstart-ui-button icon="chevron-right" type="link" class="ps-5"
                                     (click)="navigateToSubPage(subOnderdeel)">
                  {{ subOnderdeel.label }}
                </snelstart-ui-button>
              </div>
            }
          }
        }
      </snelstart-ui-table-expanded-row>
    </snelstart-ui-table-col>

    <snelstart-ui-table-col name="onderdelenAanvullendeTekst"
                            columnType="currency"
                            width="300">
      <snelstart-ui-table-col-header></snelstart-ui-table-col-header>

      <snelstart-ui-table-col-data>
        <ng-template let-record="record">
          @if (record.value === 1) {
            <ng-container>
              <a>Totaal aangiften:</a>
            </ng-container>
          }
          @else if (record.value === 3) {
            <ng-container>
              <a>Totaal suppleties:</a>
            </ng-container>
          }
          @else if (record.value === 4) {
            <ng-container>
              <a>Nog te betalen:</a>
            </ng-container>
          }
        </ng-template>
      </snelstart-ui-table-col-data>

    </snelstart-ui-table-col>

    <snelstart-ui-table-col name="berekeningDitJaar"
                            columnType="currency"
                            width="300"
    >
      @if (vatEntity && vatEntity.overzicht) {
        <snelstart-ui-table-col-header>
          {{ vatEntity.overzicht.jaar }}
        </snelstart-ui-table-col-header>
      }

      <snelstart-ui-table-col-data>
        <ng-template let-record="record">
          @let berekening = vatEntity.overzicht?.berekening;
          @if (berekening) {
            @if (record.value === 1) {
              <a>{{ (berekening.totaalAangiften ?? 0).toLocaleString() }}</a>
            }
            @if (record.value === 3) {
              <a>{{ (berekening.totaalSuppleties ?? 0).toLocaleString() }}</a>
            }
            @if (record.value === 4) {
              <a>{{ (berekening.verschuldigdeOmzetbelasting ?? 0).toLocaleString() }}</a>
            }
          }
        </ng-template>
      </snelstart-ui-table-col-data>

    </snelstart-ui-table-col>
  </snelstart-ui-table>
  <snelstart-venture-fiscaal-domain-logic-service [(dialogVisible)]="this.dialogVisible"
                                                  [title]="'Nieuwe aangifte omzetbelasting aanmaken'"
  >
  </snelstart-venture-fiscaal-domain-logic-service>
}
